import React from 'react';
import PropTypes from 'prop-types';
import CwRadioButton from '../cwradiobutton/CwRadioButton';
import css from './CwRadioButtonGroup.scss';
import CwPodCol from '../cwpod/CwPodCol';
import CwPodRow from '../cwpod/CwPodRow';

class CwRadioButtonGroup extends React.Component {

  componentWillMount() {
    // Default to first radio button if value is undefined
    if (!this.props.value) {
      // Fire onSystemChange to let consumer know it is not a user interaction change
      this.props.onSystemChange(this.props.radioButtons[0]);
    }
  }

  componentWillReceiveProps(nextProps) {
    // Default to first radio button if value is undefined
    if (!nextProps.value) {
      // Fire onSystemChange to let consumer know it is not a user interaction change
      this.props.onSystemChange(nextProps.radioButtons[0]);
    }
  }

  handleFocus = () => {
    if (this.props.disabled || !this.props.onFocus) {
      return;
    }

    this.props.onFocus();
  };

  handleBlur = () => {
    if (this.props.disabled || !this.props.onBlur) {
      return;
    }

    this.props.onBlur();
  };

  handleChange = (item) => {
    if (this.props.disabled || !this.props.onChange) {
      return;
    }
    this.props.onChange(item);
  };

  createRadioButton = (item) => {

    if (!this.props.value || this.props.value.id === undefined || !item || item.id === undefined) {
      return;
    }

    const value = {
      id: item.id,
      name: item.name,
      checked: item.id === this.props.value.id
    };
    const radioButton = <CwRadioButton cwId={`${this.props.cwId}_${item.name}`} value={value} groupName={this.props.groupName} key={item.id} onChange={this.handleChange} invalid={this.props.invalid}
      disabled={this.props.disabled} onFocus={this.handleFocus} onBlur={this.handleBlur} />;
    return <CwPodCol className={css.radioButton} key={item.id}> 
        {radioButton}
    </CwPodCol>;
  };

  getRadioButtons = () => {
    if (!this.props.radioButtons || !this.props.radioButtons.length > 0) {
      return null;
    }
    let columns = this.props.columns ? this.props.columns : this.props.radioButtons.length;
    let rows = [];
    let j = 0;
    let cells = [];
    for (let i = 0; i < this.props.radioButtons.length; i++) {
      let item = this.props.radioButtons[i];
      cells.push(this.createRadioButton(item));
      j++;
      if (j > columns - 1 || i === this.props.radioButtons.length - 1) {
        j = 0;
        rows.push(<CwPodRow className={css.alignRadioButtonsCenter} key={`item{${i}`}>{cells}</CwPodRow>);
        cells = [];
      }
    }
    return <div>{rows}</div>;
  };

  render() {
    return this.getRadioButtons();
  }
}

CwRadioButtonGroup.propTypes = {
  /**
 * Connectwise element id to be used as unique identifier
 */
  cwId: PropTypes.string,
  /**
   * Array of radio buttons for the group with {id, name} as its shape
   */
  radioButtons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * Id of radio button that should be checked, if it does not match
   * an id of a radio button on  the props.radioButtons, none will
   * be checked
   */
  value: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
  }),
  /**
   * Used to control if all radio buttons are invalid, red
   */
  invalid: PropTypes.bool,
  /**
   * Used to group radio buttons, radio buttons with the same
   * group name will have mutual exclusivity, only one radio
   * button in a group can be checked
   */
  groupName: PropTypes.string,
  /**
   * Used to lay out the radio buttons, it will display the radio buttons
   * across this many columns
   */
  columns: PropTypes.number,
  /**
   * Used to disable all radio buttons in this group
   */
  disabled: PropTypes.bool,
  /**
   * Callback function fired when a radio button in this group is clicked (by user)
   */
  onChange: PropTypes.func,
  /**
   * Callback function fired when a radio button is automatically selected (not by user)
   */
  onSystemChange: PropTypes.func,
  /**
   * Callback function fired when a radio button is focued
   */
  onFocus: PropTypes.func,
  /**
   * Callback function fired when a radio button 
   */
  onBlur: PropTypes.func,
};

export default CwRadioButtonGroup;


// WEBPACK FOOTER //
// ./src/components/cwradiobuttongroup/CwRadioButtonGroup.jsx